export default __webpack_public_path__ + "static/media/hard-job.345154fd.svg";